module.exports = __webpack_public_path__ + "img/H2.f3e2b073.png";